<template>
    <transition
        name="fade"
        mode="in-out"
    >
        <router-view id="app" />
    </transition>
</template>

<script>
export default {
    name: 'App',
    watch: {
        '$route': function() {
            document.body.classList.add(this.$route.meta.theme);

            if(!this.$route.meta.theme) {
                document.body.classList.remove('sand-purple');
            }
        },
    },
};
</script>

<style lang="scss">
// Position absolute to enable seamless fade transition.
#app {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

@import '@/assets/scss/app';
</style>
